module.exports = __webpack_public_path__ + "media/store/fonts/NouvelleGrotesque-Bold-eac9009436e6e0801787caf02209ac4e.otf";